class OntarioObstetricalNoScreeningTest {
    public IsCounseledAndDeclined?: boolean;
    public CounseledAndDeclinedDate?: Date;
    public IsPresented?: boolean;
    public IsOfferedNonInvasivePrenatalTest?: boolean;
    public OfferedNonInvasivePrenatalTestDate?: Date;

    constructor(fields?: Partial<OntarioObstetricalNoScreeningTest>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalNoScreeningTest };
